import IDream from 'motw_core/Entity/IDream';

export const IsMasterDream = (dream: IDream, allDreams: IDream[]) => {
    const hasChildren = allDreams.filter((d) => d.linkid === dream.id).length > 0;
    
    const { linkid } = dream;

    const hasNoParent =
        (linkid === undefined)
        || (linkid  === null)
        || (linkid === 0);

	const isMasterDream = hasChildren && hasNoParent;
	return isMasterDream;
};
